import { RESOURCES_NAMES } from "@/const/resource.constants"
import { useHttp } from "@/hooks/useHttp"

import type { AgentInventory } from "./agentInventory.data"

// Response of GET /api/v1/inventory/branch/{repo}/agents — the API decides, per tenant + repo, what
// to serve: `enabled` reflects whether the tenant has the feature; `inventory` is null when the repo
// has none. The web app never gates on hardcoded tenant/repo lists.
interface AgentInventoryApiResponse {
  data: {
    enabled: boolean
    inventory: AgentInventory | null
  }
}

interface UseAgentInventory {
  inventory: AgentInventory | null
  enabled: boolean
  isLoading: boolean
}

/**
 * Fetches the agent inventory for a repository from kosmos-api. `enabled` reflects whether the
 * tenant has the feature; `inventory` is the graph for the repo (null when it has none). Tab
 * availability is keyed on inventory presence (see AgentInventoryView).
 */
export const useAgentInventory = (
  repositoryName?: string
): UseAgentInventory => {
  const url = repositoryName
    ? RESOURCES_NAMES.INVENTORIES.BRANCH_AGENTS(repositoryName)
    : null
  const { response, isLoading } = useHttp<AgentInventoryApiResponse>(
    url,
    undefined,
    { enabled: !!repositoryName }
  )

  return {
    inventory: response?.data?.inventory ?? null,
    enabled: !!response?.data?.enabled,
    isLoading
  }
}
